module.exports = __webpack_public_path__ + "RishiPrakaashSM-e024e037.webp";